import Model from './model'

class Contact extends Model {
  static get name() {
    return 'contacts'
  }

  get formatted() {
    return `${this.firstName} ${this.lastName}`
  }
}

export default Contact
